import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

//SCSS
import './scss/style.scss';

ReactDOM.render(<App />, document.getElementById('root'));
